export const converter = job => {
  job.jobServices.map(jobService => {
    const { checklists } = jobService.service.currentVersion;
    const { datasheets } = jobService.service.currentVersion;
    const serviceVersion = jobService.service.currentVersion;
    serviceVersion.checklists = checklists.reduce(
      (accumulator, { checklistVersions, ...v }) => {
        let obj;
        if (checklistVersions) {
          if (checklistVersions.length > 0) {
            obj = { ...v, currentVersion: checklistVersions[0] };
          }
        } else {
          obj = { ...v };
        }
        if (obj) {
          const sections = obj?.currentVersion?.checklistSections || [];
          sections.map(checklistSection => {
            checklistSection.questions.map(question => {
              question.checklistQuestion.currentVersion.nonCompliances.map(
                nonCompliance => {
                  nonCompliance.laws.map(law => {
                    if (!law.currentVersion) {
                      const factoryCompany = job.jobCompanies.find(
                        companyItem => companyItem.company.currentVersion.companyTypes.map(c => c.id).includes(3),
                      );
                      if (factoryCompany) {
                        const lawVersion = factoryCompany.company.currentVersion.companyAddresses[0]?.currentVersion.country.laws.find(
                          el => el.id === law.id,
                        );
                        const lawForLinter = law;
                        lawForLinter.currentVersion = lawVersion?.currentVersion;
                      }
                    }
                    return law;
                  });
                  return nonCompliance;
                },
              );
              return question;
            });
            return checklistSection;
          });
          accumulator.push(obj);
        }
        return accumulator;
      },
      [],
    );
    serviceVersion.datasheets = datasheets.reduce(
      (accumulator, { datasheetVersions, ...v }) => {
        let obj;
        if (datasheetVersions) {
          if (datasheetVersions.length > 0) {
            obj = { ...v, currentVersion: datasheetVersions[0] };
          }
        } else {
          obj = { ...v };
        }
        if (obj) {
          accumulator.push(obj);
        }
        return accumulator;
      },
      [],
    );
    return jobService;
  });
  return job;
};

export default { converter };
